import React from 'react';
import ReactDOM from 'react-dom/client'
import HomeScreen from './Components/Screens/HomeScreen'
import './assets/css/sb-common.css'
import './assets/css/review-alert-settings.css'
import './assets/css/review-alert-themes.css'


const root = ReactDOM.createRoot(document.getElementById('sb-app'));
root.render(
    <HomeScreen></HomeScreen>
);